import axios from 'axios'
import store from '@/store'
import { getWorkFlowToken } from '@/utils/auth'
import constants from '@/utils/constants'
import RSAEncrypt from '@/utils/common/RSAEncrypt'
import ElementUI from 'element-ui'
import { Message, Loading } from 'element-ui'
let loadingInstance = null
const service = axios.create({
  baseURL: 'http://47.104.247.47:10013/',
  timeout: 1000 * 30
})

// request interceptor
service.interceptors.request.use(
  config => {
    var loading = false
    if (config.method === 'get') {
      if (config.params != null) {
        if (config.params.loading != null) {
          loading = config.params.loading
        }
      }
      config.params = {
        _t: Date.parse(new Date()) / 1000,
        ...config.params
      }
    }
    if (config.method === 'post') {
      if (config.data != null) {
        if (config.data instanceof FormData) {
          if (config.data.has('loading')) {
            loading = config.data.get('loading')
          }
        }
        if (config.data.loading != null) {
          loading = config.data.loading
        }
      }
    }
    console.log('loading', loading)
    if (loading && loading !== 'false') {
      loadingInstance = Loading.service({
        fullscreen: true,
        customClass: 'common-loading'
      })
    }
    if (store.getters.workFlowToken) {
      config.headers['Access-Token'] = getWorkFlowToken()
    }
    config.headers['ProjectsId'] = constants.PROJECTS_ID
    config.headers['App-Id'] = constants.APP_ID
    config.headers['App-Key'] = constants.APP_KEY
    config.headers['Application-Name'] = constants.APPLICATION_NAME
    // config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Sign'] = 'MD5=' + RSAEncrypt.paramSign(config)
    return config
  },
  error => {
    if (loadingInstance) {
      loadingInstance.close()
    }
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (loadingInstance) {
      loadingInstance.close()
    }
    if (res instanceof ArrayBuffer) {
      var resultBufferString = String.fromCharCode.apply(null, new Uint8Array(res))
      if (resultBufferString.toLocaleLowerCase().indexOf('png') > -1 || resultBufferString.toLocaleLowerCase().indexOf('jfif') > -1) {
        return res
      } else {
        resultBufferString = decodeURIComponent(escape(resultBufferString))
        resultBufferString = JSON.parse(resultBufferString)
        Message({
          message: resultBufferString.data == null ? resultBufferString.message : resultBufferString.data,
          type: 'warning',
          showClose: true,
          duration: 5 * 1000
        })
      }
    } else if (res instanceof Blob) {
      if (res.type === 'application/json') {
        const reader = new FileReader()
        reader.addEventListener('loadend', function() {
          var json = JSON.parse(reader.result)
          if (!json.success) {
            Message({
              message: json.data == null ? json.message : json.data,
              type: 'warning',
              duration: 5 * 1000
            })
          }
        })
        reader.readAsText(res, 'UTF-8')
        return Promise.reject(res)
      } else {
        return res
      }
    } else {
      if (response.config.url.indexOf('/actuator/') > -1) {
        return res
      }
      if (res.code !== 200) {
        // || res.code === 5001 || res.code === 5002
        if (res.code === 500) {
          if (res.data.requestId) {
            ElementUI.Notification({
              type: 'error',
              title: '系统异常',
              dangerouslyUseHTMLString: true,
              duration: 10 * 1000,
              message: `<div>
                  错误代码:<m style="color:red">【${res.data.errorCode}】</m><br>
                  请求码:<m style="color:red">【${res.data.requestId}】</m><br>
                  错误描述:<m style="color:red">【${res.data.errorMessage}】${res.data.errorLocalizedMessage}</m><br>
                  <br>备注:<m style="font-style: italic;">请将请求码发送给管理员排查错误!您的反馈将是我们不断进步的动力!</m><br>
                </div>`
            })
          } else {
            Message({
              message: res.data == null ? res.message : res.data,
              type: 'error',
              duration: 5 * 1000
            })
          }
        } else if (res.code === 501) {
          var html = ''
          var data = res.data
          for (var item in data) {
            html += `【${item}】<m style="color:red">${data[item]}</m><br>`
          }
          ElementUI.Notification({
            type: 'warning',
            title: res.message,
            dangerouslyUseHTMLString: true,
            duration: 10 * 1000,
            message: `<div>${html}</div>`
          })
        } else if (res.code === 506003) {
          // store.dispatch('resetToken').then(() => {
          //   location.reload()
          // })
          store.dispatch('login', { mobile: store.getters.userInfo.F_MobilePhone, username: store.getters.userInfo.LoginName })
        } else {
          Message({
            message: res.data == null ? res.message : res.data,
            type: 'warning',
            showClose: true,
            duration: 5 * 1000
          })
        }

        return Promise.reject(res)
      } else {
        return res.data
      }
    }
  },
  error => {
    if (loadingInstance) {
      loadingInstance.close()
    }
    console.log('err', error) // for debug
    Message({
      message: error.message === 'Network Error' ? '抱歉,服务忙,请稍后重试~' : error.message,
      type: 'error',
      showClose: true,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

service.get = (url, params = {}) => {
  return service({
    method: 'GET',
    url: url,
    params: params
  })
}
service.post = (url, params = {}) => {
  return service({
    method: 'POST',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
service.pictureStream = (url, params) => {
  return service({
    method: 'GET',
    url: url,
    params: params,
    responseType: 'arraybuffer'
  })
}
service.exportData = (url, params) => {
  return service({
    method: 'POST',
    url: url,
    data: params,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

service.fileUpload = (url, params) => {
  return service({
    method: 'POST',
    url: url,
    data: params,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export default service
